import { get, capitalize } from 'lodash';

function notification() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./notification.html'),
    scope: {},
    controller: 'NotificationController',
    controllerAs: 'vm',
    bindToController: {
      notification: '<'
    }
  };
}

function NotificationController($scope) {
  'ngInject';
  const vm = this;

  vm.dismiss = dismiss;
  vm.isDismissing = false;
  vm._formatTitle = _formatTitle;

  vm.$onInit = () => {
    vm.title = _formatTitle(vm.notification);
  };

  function dismiss() {
    if (!vm.isDismissing) {
      vm.isDismissing = true;
      $scope.$emit('notifications:dismiss', vm.notification);
    }
  }

  /**
   * @param {Object} notification
   * @returns {String}
   * @private
   */
  function _formatTitle(notification) {
    const customTitle = get(notification, 'message.title');
    return [
      capitalize(notification.type),
      customTitle ? `: ${customTitle}` : ''
    ].join('');
  }
}

export { notification, NotificationController };
